import React from 'react';
import { FaWhatsapp, FaTelegramPlane, FaInstagram, FaUsers } from 'react-icons/fa';
import Icon from '../../../components/AppIcon';
import { SOCIALS, WA_MESSAGES, WHATSAPP_DISPLAY, openWhatsApp } from '../../../config/site';

const BENEFITS = [
  { icon: 'Timer', title: 'Under 2 minute replies', copy: 'Measured daily. If it slips, the shift lead gets paged.', color: '#25D366' },
  { icon: 'UserCheck', title: 'One expert, start to finish', copy: 'No handovers, no repeating your problem to four people.', color: '#F0C24B' },
  { icon: 'Lock', title: 'Private and encrypted', copy: 'WhatsApp end-to-end, and we never ask for OTPs or PINs.', color: '#5B8CFF' },
  { icon: 'Gift', title: 'Bonuses applied for you', copy: 'Welcome offers, cashback and reloads set up before you play.', color: '#FF3D71' },
  { icon: 'Globe', title: 'Six Indian languages', copy: 'Write in the language you think in — someone speaks it.', color: '#B98CFF' },
  { icon: 'Moon', title: 'Genuinely 24×7', copy: '3 AM withdrawals get the same attention as 3 PM ones.', color: '#4FE0DA' },
];

const CHANNELS = [
  {
    id: 'wa',
    label: 'WhatsApp VIP desk',
    value: WHATSAPP_DISPLAY,
    note: 'Fastest route · replies in ~2 min',
    accent: '#25D366',
    icon: <FaWhatsapp size={22} />,
    action: () => openWhatsApp(WA_MESSAGES.general),
  },
  {
    id: 'tg-channel',
    label: 'Telegram channel',
    value: 'Results, bonuses & drops',
    note: 'Announcements from the team',
    accent: '#5B8CFF',
    icon: <FaTelegramPlane size={21} />,
    href: SOCIALS.telegramChannel,
  },
  {
    id: 'tg-group',
    label: 'Telegram community',
    value: 'Players helping players',
    note: 'Tips, tables and banter',
    accent: '#69A8FF',
    icon: <FaUsers size={20} />,
    href: SOCIALS.telegramGroup,
  },
  {
    id: 'ig',
    label: 'Instagram',
    value: '@nitinn_online_book',
    note: 'Winner reels and behind the scenes',
    accent: '#FF3D71',
    icon: <FaInstagram size={22} />,
    href: SOCIALS.instagram,
  },
];

const ContactMethods = () => (
  <section className="relative overflow-hidden py-24">
    <span className="aurora left-[-10%] top-[12%] h-96 w-96 bg-royal-gold/20" aria-hidden="true" />

    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <span className="badge-pill"><Icon name="MessageSquareHeart" size={13} /> Why WhatsApp</span>
        <h2 className="mt-6 font-heading text-display font-bold text-white">
          Support that behaves like a <span className="gold-text">friend, not a form</span>
        </h2>
        <p className="mt-4 text-body-lg text-white/60">
          Everything — sign up, login, app download, deposits, payouts, strategy — happens in one thread you can
          scroll back through any time.
        </p>
      </div>

      <div className="perspective mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {BENEFITS.map((b, i) => (
          <div key={b.title} className="card-3d animate-rise p-6" style={{ animationDelay: `${i * 60}ms` }}>
            <span
              className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl"
              style={{ background: `${b.color}1F` }}
            >
              <Icon name={b.icon} size={22} color={b.color} />
            </span>
            <h3 className="font-display text-base font-semibold text-white">{b.title}</h3>
            <p className="mt-1.5 text-sm text-white/55">{b.copy}</p>
          </div>
        ))}
      </div>

      {/* Channels */}
      <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {CHANNELS.map((c) => {
          const inner = (
            <>
              <span
                className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl text-white"
                style={{ background: `linear-gradient(160deg, ${c.accent}, ${c.accent}66)` }}
              >
                {c.icon}
              </span>
              <h3 className="font-display text-sm font-semibold text-white">{c.label}</h3>
              <p className="mt-1 truncate text-sm text-white/70">{c.value}</p>
              <p className="mt-2 text-xs text-white/40">{c.note}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-medium" style={{ color: c.accent }}>
                Open <Icon name="ArrowUpRight" size={13} />
              </span>
            </>
          );

          return c.href ? (
            <a key={c.id} href={c.href} target="_blank" rel="noopener noreferrer" className="card-flat block p-6 transition hover:-translate-y-1 hover:border-white/25">
              {inner}
            </a>
          ) : (
            <button key={c.id} onClick={c.action} className="card-flat block p-6 text-left transition hover:-translate-y-1 hover:border-wa-green/50">
              {inner}
            </button>
          );
        })}
      </div>
    </div>
  </section>
);

export default ContactMethods;
